/** The package screen: where the organization stands, and what each package includes. */
const en = {
  title: 'Package & usage',
  onPlanPrefix: "You're on the",
  onPlanSuffix: 'package',
  legacyNote:
    'This package is from the previous price list. It stays exactly as it is until we move you to a current one.',
  usageTitle: 'This month',
  resets: (date: string) => `Session count resets on ${date}.`,
  metric: {
    sessions: 'Recorded sessions',
    projects: 'Projects',
    integrations: 'Integration tools',
  } as Record<string, string>,
  unlimited: 'Unlimited',
  notIncluded: 'Not in your package',
  addon: (n: string) => `includes ${n} from add-ons`,
  warn: 'Over 80% used',
  full: 'Limit reached',
  dailyCap: (n: string) => `Daily cap on this package: ${n} sessions`,
  catalogTitle: 'Packages',
  catalogNote: 'Prices are quoted by our team, and add-ons raise a single limit: 1,000 sessions, one project or one integration tool.',
  noPlans: 'No packages configured.',
  sessionsPerMonth: (n: string) => `${n} sessions / month`,
  unlimitedSessions: 'Unlimited sessions',
  sessionsPerDay: (n: string) => `${n} sessions / day`,
  projects: (n: number) => (n === 1 ? '1 project' : `${n} projects`),
  unlimitedProjects: 'Unlimited projects',
  integrations: (n: number) => `${n} integration tools`,
  unlimitedIntegrations: 'Unlimited integration tools',
  noIntegrations: 'No integrations',
  retention: (d: number) => `${d}-day retention`,
  coverOpsIncluded: 'CoverOps integration',
  coverOpsAddon: 'CoverOps integration (add-on)',
  masking: 'Dynamic masking',
  sso: 'Single sign-on',
  free: 'Free',
  priceOnRequest: 'Price on request',
  current: 'Current',
  currentPlan: 'Current package',
  contactSales: 'Talk to us',
  license: {
    title: 'Licence',
    customer: 'Licensed to',
    package: 'Package',
    expires: 'Valid until',
    noEnd: 'No end date',
    addons: 'Add-ons',
    none: 'None',
    state: { licensed: 'Valid', grace: 'Grace period', stopped: 'Recording stopped' } as Record<string, string>,
    unlicensed: 'No valid licence installed. Running as Startup during the grace period.',
    graceEnds: (date: string) => `Grace ends ${date}`,
  },
};

const tr: typeof en = {
  title: 'Paket ve kullanım',
  onPlanPrefix: 'Şu anda',
  onPlanSuffix: 'paketindesiniz',
  legacyNote:
    'Bu paket önceki fiyat listesinden. Sizi güncel bir pakete geçirene kadar olduğu gibi kalır.',
  usageTitle: 'Bu ay',
  resets: (date: string) => `Oturum sayacı ${date} tarihinde sıfırlanır.`,
  metric: {
    sessions: 'Kaydedilen oturum',
    projects: 'Proje',
    integrations: 'Entegrasyon aracı',
  },
  unlimited: 'Sınırsız',
  notIncluded: 'Paketinizde yok',
  addon: (n: string) => `${n} tanesi ek paketten`,
  warn: '%80 aşıldı',
  full: 'Sınıra ulaşıldı',
  dailyCap: (n: string) => `Bu paketin günlük sınırı: ${n} oturum`,
  catalogTitle: 'Paketler',
  catalogNote: 'Fiyatları ekibimiz iletir. Ek paketler tek bir sınırı artırır: 1.000 oturum, bir proje ya da bir entegrasyon aracı.',
  noPlans: 'Tanımlı paket yok.',
  sessionsPerMonth: (n: string) => `ayda ${n} oturum`,
  unlimitedSessions: 'Sınırsız oturum',
  sessionsPerDay: (n: string) => `günde ${n} oturum`,
  projects: (n: number) => `${n} proje`,
  unlimitedProjects: 'Sınırsız proje',
  integrations: (n: number) => `${n} entegrasyon aracı`,
  unlimitedIntegrations: 'Sınırsız entegrasyon aracı',
  noIntegrations: 'Entegrasyon yok',
  retention: (d: number) => `${d} gün saklama`,
  coverOpsIncluded: 'CoverOps entegrasyonu',
  coverOpsAddon: 'CoverOps entegrasyonu (ek paket)',
  masking: 'Dinamik maskeleme',
  sso: 'Tek oturum açma (SSO)',
  free: 'Ücretsiz',
  priceOnRequest: 'Fiyat için bize ulaşın',
  current: 'Mevcut',
  currentPlan: 'Mevcut paket',
  contactSales: 'Bize ulaşın',
  license: {
    title: 'Lisans',
    customer: 'Lisans sahibi',
    package: 'Paket',
    expires: 'Geçerlilik',
    noEnd: 'Bitiş tarihi yok',
    addons: 'Ek paketler',
    none: 'Yok',
    state: { licensed: 'Geçerli', grace: 'Ek süre', stopped: 'Kayıt durdu' },
    unlicensed: 'Geçerli bir lisans yüklü değil. Ek süre boyunca Startup olarak çalışıyor.',
    graceEnds: (date: string) => `Ek süre ${date} tarihinde bitiyor`,
  },
};

export const billing = { en, tr };
